import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES, PRICE } from '../data/offer';
import { Reveal } from './Reveal';
import { LockOpenIcon, SparkIcon, VaultIcon } from './icons/CraftIcons';
export function Revelation() {
  return <section aria-labelledby="revelation" className="relative w-full overflow-hidden border-y border-hairline bg-ink px-4 py-10 sm:px-6 sm:py-14 lg:py-24" data-id="element-356" data-mp="1s5ux5pkm2qs">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 hidden h-64 w-64 -translate-x-1/2 rounded-full bg-gold/15 blur-3xl sm:block" data-id="element-357" data-mp="bkbmiebwui5g" />
      <div className="relative mx-auto grid max-w-[1120px] items-center gap-8 sm:gap-12 lg:grid-cols-[1.05fr_0.95fr]" data-id="element-358" data-mp="kjqbf9cfiknu">
        <Reveal data-id="element-359" data-mp="pi9wz8n41ufo">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-gold-light" data-id="element-360" data-mp="pit5jyqvf6h1">
            <SparkIcon className="h-3.5 w-3.5" data-id="element-361" data-mp="2rbhb4eqzm5zz" />
            Section 3 — The revelation
          </span>
          <h2 id="revelation" className="mt-4 font-display text-3xl font-bold leading-tight text-cream sm:text-[40px]" data-id="element-362" data-mp="3hjcis4elqhad">
            What if you never had to pay for a pattern again?
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-cream/70 sm:text-base" data-id="element-363" data-mp="37plvh2u7ocw9">
            What if every viral trend you saw on TikTok was already in your library, waiting for you?
          </p>

          <p className="mt-7 font-display text-2xl font-extrabold uppercase tracking-wide text-gold-light sm:text-3xl" data-id="element-364" data-mp="48vl6brljdor">
            The Ultimate Crochet Treasury 2026
          </p>

          <p className="mt-4 text-sm leading-relaxed text-cream/70 sm:text-base" data-id="element-365" data-mp="3re4ibdrqve7s">
            This isn&rsquo;t a &ldquo;book.&rdquo; It&rsquo;s a{' '}
            <strong className="font-bold text-cream" data-id="element-366" data-mp="2g12bhafg630t">Hostile Takeover of the Craft Industry</strong>.
            We&rsquo;ve consolidated ${PRICE.totalValue}+ worth of professional assets into one single
            digital vault for a price so low it feels like a mistake.
          </p>

          <div className="mt-6 flex flex-wrap gap-3 sm:mt-7" data-id="element-367" data-mp="2hihg4bwc44on">
            <span className="inline-flex items-center gap-2 rounded-xl border border-cream/15 bg-cream/5 px-4 py-2.5 text-xs font-bold text-cream" data-id="element-368" data-mp="2hfv7sa1mdl5d">
              <VaultIcon className="h-4 w-4 text-gold-light" data-id="element-369" data-mp="27j0afuh31qso" />
              15 PDFs, one vault
            </span>
            <span className="inline-flex items-center gap-2 rounded-xl border border-cream/15 bg-cream/5 px-4 py-2.5 text-xs font-bold text-cream" data-id="element-370" data-mp="1trbybr6u32bp">
              <LockOpenIcon className="h-4 w-4 text-gold-light" data-id="element-371" data-mp="1ykwnctqg8lyr" />
              Commercial rights unlocked
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="perspective-stage" data-id="element-372" data-mp="1ou247y8i22hj">
          <motion.div className="mx-auto w-full max-w-md" initial={{
          rotateY: 16,
          scale: 0.92,
          opacity: 0
        }} whileInView={{
          rotateY: 6,
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-373" data-mp="1atr7iekidtog">
            <div className="animate-floaty" data-id="element-374" data-mp="r8r0w9rcjk3j">
              <img src={IMAGES.treasuryBook} alt="The Ultimate Crochet Treasury hardcover book standing on a light wooden table beside sage yarn and a crochet hook" className="w-full rounded-3xl border border-cream/10 object-cover shadow-deep" loading="lazy" decoding="async" width={1024} height={1024} data-id="element-375" data-mp="ra27sig397yv" />
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>;
}